import { shouldLogOutOnForbidden } from '@/lib/api/twoFactorEnrollment';
import { generalApi } from '@/lib/api/general';
import {
  dispatchCheckApiError,
  dispatchLogOut,
  MainContext,
} from '../actionsMain';
import { AxiosError } from 'axios';
import { ApiErrorResponse } from '@/interfaces/api/general/errorResponses';
import { commitAddNotification, commitSetForceEnroll2Fa } from '../mutations';
import { defineMessages } from '@/lib/i18n';

const m = defineMessages({
  saveEnforce2Fa: '二要素認証の設定を保存しました',
});

export const actionGetEnforce2Fa = async (
  context: MainContext,
  payload: {
    companyId: string;
  }
) => {
  try {
    return await generalApi.getEnforce2Fa(payload.companyId);
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};

export const actionUpdateEnforce2Fa = async (
  context: MainContext,
  payload: {
    companyId: string;
    enabled: boolean;
  }
) => {
  try {
    await generalApi.updateEnforce2Fa(payload.companyId, {
      enabled: payload.enabled,
    });

    commitAddNotification(context, {
      messageKey: m.saveEnforce2Fa,
      color: 'success',
    });
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};

// 取得に失敗した場合は強制しない（サーバー側のセッション失効が最終防衛線）。
export const actionFetchForceEnroll2Fa = async (context: MainContext) => {
  try {
    const { data } = await generalApi.get2FaEnrollment();
    commitSetForceEnroll2Fa(context, data.forceEnroll);
  } catch (error) {
    console.error('Failed to fetch 2FA enrollment status:', error);
    commitSetForceEnroll2Fa(context, false);
  }
};
